@if (visivel()) {
  @if (chegando()) {
    <!-- Chegada (só desktop): faixa de luz estilo Echo Show, abaixo da barra do menu, que acende da
         direita para a esquerda e apaga de cima para baixo; a minhoca (2 traços no MESMO caminho:
         halo + fio) desce junto com a frente que se apaga e contorna a aba. pointer-events: none no CSS. -->
    <span class="ai-aba-faixa" aria-hidden="true"></span>
    <svg class="ai-aba-minhoca" aria-hidden="true" focusable="false"
         [attr.viewBox]="'0 0 ' + faixaLargura + ' ' + alturaMinhoca()"
         [style.height.px]="alturaMinhoca()"
         [style.--ai-minhoca-fim-descida]="fimDescidaMinhoca()">
      <path class="ai-aba-minhoca-halo" [attr.d]="caminhoMinhoca()" pathLength="1000" />
      <path class="ai-aba-minhoca-fio" [attr.d]="caminhoMinhoca()" pathLength="1000" />
    </svg>
  }
  <button type="button" class="ai-aba" [class.is-acoplada]="acoplada()" [class.is-arrastando]="!!layout.arrastando()"
          [class.is-chamando]="chamando()" [class.is-chegando]="chegando()"
          [style.right.px]="acoplada() ? layout.larguraEfetiva() : 0"
          [attr.aria-label]="acoplada() ? 'Fechar assistente' : 'Abrir assistente'"
          [attr.aria-expanded]="acoplada()" (click)="clicar()">
    <mat-icon>{{ acoplada() ? 'chevron_right' : 'graphic_eq' }}</mat-icon>
    @if (!acoplada() && svc.naoLidos() > 0) {
      <one-badge variant="danger" size="sm" [round]="true" class="ai-aba-badge">{{ naoLidosLabel() }}</one-badge>
    }
    <!-- Brilho "metal polido" (sempre): recorte com o raio da aba; o ::after (gradiente) atravessa por transform. -->
    <span class="ai-aba-brilho" aria-hidden="true"></span>
  </button>
}
